import universal from 'react-universal-component';

export default universal(() => import('./Auction10'));



// WEBPACK FOOTER //
// ./src/app/views/Auction10/index.js